import React, {useEffect} from 'react';
import {Button, Col, Row} from 'antd';
import {translate} from 'react-i18next';
import EnhancedModal from "../../../../../components/enhanced-modal";
import {
    getMappingSetPreviewToken,
    resetMappingSetValidations,
    validateMappingSetData,
    validateMappingSetDataset,
    validateMappingSetFormat,
    validateMappingSetMapping,
} from "../actions";
import {compose} from "redux";
import {connect} from "react-redux";
import {GUTTER_SM, MODAL_WIDTH_LG} from "../../../../../styles/constants";
import MappingSetValidateStatus from "./MappingSetValidateStatus";

const mapStateToProps = ({
                             scenes: {mappingHandler: {mappingSet: {wizard, index}}}
                         }) => ({
    dataflow: index.dataflow,
    selectedMappingSet: wizard.selectedMappingSet,
    validateFormatStatus: wizard.validateFormatStatus,
    validateDataStatus: wizard.validateDataStatus,
    validateMappingStatus: wizard.validateMappingStatus,
    validateDatasetStatus: wizard.validateDatasetStatus,
    mappingSetPreviewToken: wizard.mappingSetPreviewToken,
});

const mapDispatchToProps = (dispatch) => {
    return {
        onResetValidateMappingSet: () => dispatch(resetMappingSetValidations()),
        onGetMappingSetPreview: (dataflowId, dataflowAgency, dataflowVersion, token) => dispatch(getMappingSetPreviewToken(dataflowId, dataflowAgency, dataflowVersion, token)),
        onValidateFormat: ({
                                Agency,
                                Version1,
                                Version2,
                                DataflowId,
                                MappingsetId
                            }) => dispatch(validateMappingSetFormat(Agency, Version1, Version2, DataflowId, MappingsetId)),
        onValidateMapping: ({
                                Agency,
                                Version1,
                                Version2,
                                DataflowId,
                                MappingsetId
                            }) => dispatch(validateMappingSetMapping(Agency, Version1, Version2, DataflowId, MappingsetId)),
        onValidateData: ({
                             Agency,
                             Version1,
                             Version2,
                             DataflowId,
                             MappingsetId
                         }) => dispatch(validateMappingSetData(Agency, Version1, Version2, DataflowId, MappingsetId)),
        onValidateDataset: ({
                                Agency,
                                Version1,
                                Version2,
                                DataflowId,
                                MappingsetId
                            }) => dispatch(validateMappingSetDataset(Agency, Version1, Version2, DataflowId, MappingsetId)),
    }
}

const getTitleFromType = (type, t) => {
    switch (type) {
        case "format":
            return t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.formatTitle");
        case "data":
            return t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.dataTitle")
        case "dataset":
            return t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.datasetTitle")
        case "mapping":
            return t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.mappingTitle")
        case "preview":
            return t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.previewTitle")
        default:
            return t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.datasetTitle")

    }
}


const ValidationAlert = ({
                             t,
                             isVisible,
                             onHide,
                             type,
                             dataflow,
                             selectedMappingSet,
                             validateFormatStatus,
                             validateDataStatus,
                             validateMappingStatus,
                             validateDatasetStatus,
                             onResetValidateMappingSet,
                             openPreviewCallback,
                             onGetMappingSetPreview,
                             onValidateFormat,
                             onValidateMapping,
                             onValidateData,
                             onValidateDataset,
                             mappingSetPreviewToken
                         }) => {
    useEffect(() => {
        const [version1, version2] = dataflow.version.split('.');
        if (type === "format") {
            onValidateFormat({
                Agency: dataflow.agencyID,
                Version1: version1,
                Version2: version2,
                DataflowId: dataflow.id,
                MappingsetId: selectedMappingSet.entityId,
            })
        }
        if (type === "data") {
            onValidateData({
                Agency: dataflow.agencyID,
                Version1: version1,
                Version2: version2,
                DataflowId: dataflow.id,
                MappingsetId: selectedMappingSet.entityId,
            })
        }
        if (type === "dataset") {
            onValidateDataset({
                Agency: dataflow.agencyID,
                Version1: version1,
                Version2: version2,
                DataflowId: dataflow.id,
                MappingsetId: selectedMappingSet.entityId,
            })
        }
        if (type === "mapping") {
            onValidateMapping({
                Agency: dataflow.agencyID,
                Version1: version1,
                Version2: version2,
                DataflowId: dataflow.id,
                MappingsetId: selectedMappingSet.entityId,
            })
        }
        if (type === "preview") {
            onGetMappingSetPreview(dataflow.id, dataflow.agencyID, dataflow.version, mappingSetPreviewToken);
            openPreviewCallback();
            onHide();
        }
    }, [dataflow, selectedMappingSet, type]);

    return (
        <EnhancedModal
            visible={isVisible}
            onCancel={() => {
                onResetValidateMappingSet()
                onHide();
            }}
            footer={<Row type="flex" justify="end" align="middle" gutter={GUTTER_SM}>
                <Col>
                    <Button onClick={() => {
                        onResetValidateMappingSet()
                        onHide();
                    }}>{t('commons.buttons.close.title')}</Button>
                </Col>
            </Row>}
            width={MODAL_WIDTH_LG}
            title={getTitleFromType(type, t)}
        >
            {type !== "preview" && (!!validateFormatStatus || !!validateDataStatus || !!validateMappingStatus || !!validateDatasetStatus) &&
                <MappingSetValidateStatus type={type}/>}
        </EnhancedModal>
    )
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
)(ValidationAlert);
